import c from 'classnames';

import { Button, Typography } from '@repo/ui';
import { Markdown } from 'components/Markdown/Markdown';
import { AIMessageFeedback } from './AIMessageFeedback';

import styles from './AIMessage.module.scss';

interface AIMessageMetadata {
  isError?: boolean;
  errorCategory?: string | null;
  errorCode?: string | null;
}

interface AIMessageProps {
  message: string;
  messageId: string;
  isStreaming: boolean;
  hasFeedback: boolean;
  onFeedbackSubmitted: (messageId: string) => void;
  metadataJson?: Record<string, unknown> | null;
  onRetry?: () => void;
  className?: string;
}

export const AIMessage = ({
  message,
  messageId,
  isStreaming,
  hasFeedback,
  onFeedbackSubmitted,
  metadataJson,
  onRetry,
  className,
}: AIMessageProps) => {
  const meta = (metadataJson ?? null) as AIMessageMetadata | null;
  const isGeneralError =
    meta?.isError === true && meta?.errorCategory !== 'content_boundary';

  if (isGeneralError) {
    return (
      <div className={c(styles.aiMessage, styles.errorMessage, className)}>
        <Typography variant='body-s' className={styles.errorText}>
          Oh no! Something went wrong!
        </Typography>
        {onRetry && (
          <Button
            variant='text'
            size='small'
            color='purple'
            iconNameLeft='refreshCcw'
            label='Try again'
            onClick={onRetry}
            className={c(styles.retryButton, 'mt-2')}
          />
        )}
      </div>
    );
  }

  return (
    <div className={c(styles.aiMessage, className)}>
      <Markdown className={styles.messageContent}>{message}</Markdown>
      {!isStreaming && !hasFeedback && (
        <AIMessageFeedback
          messageId={messageId}
          isStreaming={isStreaming}
          onFeedbackSubmitted={onFeedbackSubmitted}
        />
      )}
    </div>
  );
};
